import {SqlField} from './SqlField';

export class SqlRow {
fields: SqlField[];
}

